import { render, staticRenderFns } from "./Huay.vue?vue&type=template&id=25a6fc53&scoped=true&"
import script from "./Huay.vue?vue&type=script&lang=js&"
export * from "./Huay.vue?vue&type=script&lang=js&"
import style0 from "./Huay.vue?vue&type=style&index=0&id=25a6fc53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a6fc53",
  null
  
)

export default component.exports